var _defs, _path, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeetings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.69 56.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d7e8f0;\n        stroke: #d7e8f0;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 2px;\n      }\n\n      .cls-3, .cls-2 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #1d47b1;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.1,42.48c-4.77,5.27-13.71,3.82-15.28-4.77-1.57-8.59,5.86-10.48,7.69-13.63,2.57-4.42,1.2-12.36,9.57-12.92,8.54-.57,5.99,9.65,13,9.5,23.5-.5,15.5,25.54,2.5,22.7-6.35-1.39-11.78-7.17-17.48-.88Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.63,29.52c2.96,0,5.36,2.39,5.36,5.36v8.02H12.27v-8.02c0-2.96,2.39-5.36,5.36-5.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.35,23.47c2.96,0,5.36,2.39,5.36,5.35v14.07h-10.71v-14.07c0-2.96,2.39-5.35,5.36-5.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.07,29.52c2.96,0,5.36,2.39,5.36,5.36v4.77c0,1.78-1.45,3.23-3.23,3.23h-7.48v-8.02c0-2.96,2.39-5.35,5.36-5.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.47,19.75c1.64,0,2.98-1.33,2.98-2.97s-1.33-2.98-2.98-2.98-2.98,1.33-2.98,2.98,1.33,2.97,2.98,2.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.23,26.09c1.64,0,2.98-1.33,2.98-2.98s-1.33-2.98-2.98-2.98-2.98,1.33-2.98,2.98,1.33,2.98,2.98,2.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.46,26.09c1.64,0,2.98-1.33,2.98-2.98s-1.33-2.98-2.98-2.98-2.98,1.33-2.98,2.98,1.33,2.98,2.98,2.98Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 56.69,
    height: 56.69
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetings);
export default __webpack_public_path__ + "static/media/meetings.3e1a5e13ebe83ccd666a667228eefa61.svg";
export { ForwardRef as ReactComponent };